import { emptyDelta } from "components/message-editor";
import { getTemplateGroup_templateGroup_templates as getTemplateFull,
  templateGroups_templateGroups_templates as getTemplateShort,
  TemplateType,
  getTemplateGroup_templateGroup as Template } from "types/gql-types";
import { Delta } from "components/message-editor/types";


type grabTemplateWithInput =
  <T extends getTemplateShort|getTemplateFull>(param: T[], input: TemplateType) => T | undefined;
const grabTemplate:grabTemplateWithInput =
(templates, inputType) =>
  templates.find(({ type }) => type === inputType);

type grabTemplateType =
  <T extends getTemplateShort|getTemplateFull>(param: T[]) => T | undefined;

export const grabSmsTemplate:grabTemplateType = (templates) =>
  grabTemplate(templates, TemplateType.SMS);

export const grabEmailTemplate:grabTemplateType = (templates) =>
  grabTemplate(templates, TemplateType.EMAIL);

export const grabLetterTemplate:grabTemplateType = (templates) =>
  grabTemplate(templates, TemplateType.LETTER);

type MessageValues = {
  smsId: string;
  letterId: string;
  emailId: string;
  smsValue: Delta;
  emailValue: Delta;
  emailSubject: string;
  letterValue: Delta;
}

export const calculateMessageValues = (template: Template | null): MessageValues | null => {
  if (!template) return null;
  const emptyTemplate = { id: "", body: JSON.stringify(emptyDelta), subject: "" };
  const smsTemplate = grabSmsTemplate(template.templates) || emptyTemplate;
  const letterTemplate = grabLetterTemplate(template.templates) || emptyTemplate;
  const emailTemplate = grabEmailTemplate(template.templates) || emptyTemplate;
  return {
    smsId: smsTemplate.id,
    letterId: letterTemplate.id,
    emailId: emailTemplate.id,
    smsValue: smsTemplate.body ? JSON.parse(smsTemplate.body) : emptyDelta,
    emailValue: emailTemplate.body ? JSON.parse(emailTemplate.body) : emptyDelta,
    emailSubject: emailTemplate.subject || "",
    letterValue: letterTemplate.body ? JSON.parse(letterTemplate.body) : emptyDelta,
  };
};
